import {
  MessagesSquare,
  LayoutDashboard,
  CalendarRange,
  Grid3x3,
  AlertTriangle,
  Wallet,
  Landmark,
  Gavel,
  Users,
  FileSignature,
  Building2,
  DoorOpen,
  UserSquare2,
  PiggyBank,
  Gauge,
  Calculator,
  Receipt,
  FileText,
  Mail,
  Mailbox,
  CheckSquare,
  BellRing,
  Wrench,
  HardHat,
  ClipboardList,
  CalendarClock,
  KeyRound,
  LineChart,
  FileBarChart,
  Upload,
  Sparkles,
  Settings,
  ShieldCheck,
  type LucideIcon,
} from 'lucide-react';

export interface NavItem {
  to: string;
  label: string;
  icon: LucideIcon;
  permission?: string;
  /** Ausblenden, wenn der Benutzer diese Berechtigung hat (z. B. ersetzt durch eine umfassendere Seite) */
  hideWithPermission?: string;
  badgeKey?: string;
}

export interface NavGroup {
  label: string;
  items: NavItem[];
}

export const NAVIGATION: NavGroup[] = [
  {
    label: 'Übersicht',
    items: [{ to: '/', label: 'Dashboard', icon: LayoutDashboard }],
  },
  {
    label: 'Mietbuchhaltung',
    items: [
      { to: '/mietuebersicht', label: 'Mietübersicht', icon: CalendarRange, permission: 'finance.read' },
      { to: '/heatmap', label: 'Zahlungs-Heatmap', icon: Grid3x3, permission: 'finance.read' },
      { to: '/rueckstaende', label: 'Mietrückstände', icon: AlertTriangle, permission: 'finance.read' },
      { to: '/zahlungen', label: 'Zahlungen', icon: Wallet, permission: 'finance.read' },
      { to: '/bank', label: 'Bankabgleich', icon: Landmark, permission: 'bank.read', badgeKey: 'bank' },
      { to: '/mahnwesen', label: 'Mahnwesen', icon: Gavel, permission: 'dunning.read', badgeKey: 'dunning' },
    ],
  },
  {
    label: 'Verwaltung',
    items: [
      { to: '/mieter', label: 'Mieter', icon: Users, permission: 'tenants.read' },
      { to: '/mietverhaeltnisse', label: 'Mietverhältnisse', icon: FileSignature, permission: 'contracts.read' },
      { to: '/immobilien', label: 'Immobilien', icon: Building2, permission: 'masterdata.read' },
      { to: '/einheiten', label: 'Einheiten & Leerstand', icon: DoorOpen, permission: 'masterdata.read' },
      { to: '/eigentuemer', label: 'Eigentümer', icon: UserSquare2, permission: 'masterdata.read' },
      { to: '/kautionen', label: 'Kautionen', icon: PiggyBank, permission: 'contracts.read' },
      { to: '/zaehler', label: 'Zähler', icon: Gauge, permission: 'utilities.read' },
      { to: '/schluessel', label: 'Schlüssel & Übergaben', icon: KeyRound, permission: 'contracts.read' },
    ],
  },
  {
    label: 'Kosten',
    items: [
      { to: '/nebenkosten', label: 'Nebenkosten', icon: Calculator, permission: 'utilities.read' },
      { to: '/ausgaben', label: 'Ausgaben', icon: Receipt, permission: 'expenses.read' },
      { to: '/finanzen', label: 'Finanzübersicht', icon: LineChart, permission: 'reports.read' },
    ],
  },
  {
    label: 'Organisation',
    items: [
      { to: '/aufgaben', label: 'Aufgaben', icon: CheckSquare, permission: 'tasks.read' },
      { to: '/wiedervorlagen', label: 'Wiedervorlagen', icon: BellRing, permission: 'tasks.read' },
      { to: '/schaeden', label: 'Schäden & Reparaturen', icon: Wrench, permission: 'tickets.read' },
      { to: '/auftraege', label: 'Handwerker-Aufträge', icon: ClipboardList, permission: 'tickets.read' },
      { to: '/handwerker', label: 'Handwerker', icon: HardHat, permission: 'tickets.read' },
      { to: '/wartung', label: 'Wartungspläne', icon: CalendarClock, permission: 'tickets.read' },
      { to: '/dokumente', label: 'Dokumente', icon: FileText, permission: 'documents.read' },
      { to: '/kommunikation', label: 'Kommunikation', icon: Mail, permission: 'communication.read' },
      { to: '/postausgang', label: 'Postausgang', icon: Mailbox, permission: 'communication.read' },
    ],
  },
  {
    label: 'Auswertung & System',
    items: [
      { to: '/berichte', label: 'Berichte & Export', icon: FileBarChart, permission: 'reports.read' },
      { to: '/import', label: 'Datenimport', icon: Upload, permission: 'import.run' },
      { to: '/assistent', label: 'KI-Assistent', icon: MessagesSquare, permission: 'assistant.use' },
      { to: '/ki', label: 'KI-Auswertungen', icon: Sparkles, permission: 'ai.use', hideWithPermission: 'assistant.use' },
      { to: '/einstellungen', label: 'Einstellungen', icon: Settings, permission: 'settings.read' },
      { to: '/audit', label: 'Audit-Log', icon: ShieldCheck, permission: 'audit.read' },
    ],
  },
];
